export type InteractiveKind = 'card-flip' | 'matching' | 'reflection' | 'drag-drop';

const KNOWN: readonly InteractiveKind[] = ['card-flip', 'matching', 'reflection', 'drag-drop'];

/** Canonical sub-body key each variant is stored under. The admin editors
 *  write exactly one of these, so its presence identifies the variant. */
const BODY_KEY: Record<InteractiveKind, string> = {
  'card-flip': 'cards',
  matching: 'matching',
  reflection: 'reflection',
  'drag-drop': 'dragDrop',
};

/**
 * Which interactive variant a body plays.
 *
 * <p>Prefers the explicit {@code interactiveKind} discriminator. Rows
 * saved before the admin editor stamped it (a card-flip left on the
 * dropdown's default never wrote one) fall back to the single canonical
 * sub-body present. Ambiguous or empty bodies resolve to {@code null} —
 * guessing between two variants would play the wrong exercise.
 */
export function resolveInteractiveKind(
  body: Record<string, unknown> | null | undefined,
): InteractiveKind | null {
  if (!body) return null;
  const explicit = body.interactiveKind;
  if (typeof explicit === 'string' && (KNOWN as readonly string[]).includes(explicit)) {
    return explicit as InteractiveKind;
  }
  const [only, second] = KNOWN.filter((k) => {
    const v = body[BODY_KEY[k]];
    return v != null && typeof v === 'object';
  });
  return only && !second ? only : null;
}
